<mat-form-field [ngClass]="{'min-height-applied' : minHeight, 'filter-field': true, 'employee-search-inputs': true}"
    appearance="outline">
    <mat-select [placeholder]="placeholder" [formControl]="employeeMultiCtrl" *ngIf="!isInputSearch && !isMultiSelect">
        <!-- Custom Trigger to show profile image when selected -->
        <mat-select-trigger>
            <div class="selected-employee-trigger !gap-2" *ngIf="getSelectedDisplayName(); else employeePlaceholder">
                <ng-container *ngIf="getSelectedUser() as selected">
                    <div class="trigger-profile-image-wrapper">
                        <img [src]="selected.meta?.profile_image_url" class="trigger-profile-image" alt="Profile"
                            *ngIf="selected.meta?.profile_image_url && selected.meta.profile_image_url !== 'null'" />
                        <div class="trigger-default-avatar-wrapper"
                            *ngIf="!selected.meta?.profile_image_url || selected.meta.profile_image_url === 'null'">
                            <ngx-avatars [initialsSize]="2" [textSizeRatio]="3" size="28" [name]="selected.name">
                            </ngx-avatars>
                        </div>
                    </div>
                </ng-container>
                <div class="trigger-default-avatar-wrapper" *ngIf="!getSelectedUser()">
                    <ngx-avatars [initialsSize]="2" [textSizeRatio]="3" size="28" [name]="getSelectedDisplayName()">
                    </ngx-avatars>
                </div>
                <span class="trigger-employee-name">{{ getSelectedDisplayName() }}</span>
                <span
                    *ngIf="showRustAgentBetaBadge()"
                    class="agent-beta-badge agent-beta-badge--name"
                    [matTooltip]="sysConfig.rustAgentNameBadgeTooltip"
                    matTooltipPosition="below">{{ sysConfig.rustAgentBetaBadge }}</span>
            </div>
            <ng-template #employeePlaceholder>
                <span>{{ placeholder }}</span>
            </ng-template>
        </mat-select-trigger>

        <!-- Search Input -->
        <div class="bg-[#f1f1f1] sticky top-0 px-2 py-2 z-10">
            <div
                class="relative bg-white rounded-lg transition-all duration-300 ease-out origin-right w-full border border-gray-300 border-solid px-3 flex items-center">
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="mr-1">
                    <path
                        d="M15.0259 13.8478L18.5951 17.4162L17.4159 18.5953L13.8476 15.0262C12.5199 16.0905 10.8684 16.6694 9.16675 16.667C5.02675 16.667 1.66675 13.307 1.66675 9.16699C1.66675 5.02699 5.02675 1.66699 9.16675 1.66699C13.3067 1.66699 16.6667 5.02699 16.6667 9.16699C16.6692 10.8687 16.0903 12.5201 15.0259 13.8478ZM13.3542 13.2295C14.4118 12.1419 15.0025 10.684 15.0001 9.16699C15.0001 5.94366 12.3892 3.33366 9.16675 3.33366C5.94341 3.33366 3.33341 5.94366 3.33341 9.16699C3.33341 12.3895 5.94341 15.0003 9.16675 15.0003C10.6838 15.0027 12.1417 14.4121 13.2292 13.3545L13.3542 13.2295Z"
                        fill="#B3B3B3" />
                </svg>
                <input #searchInp [formControl]="employeeSearchCtrl" [placeholder]="placeholder"
                    (keydown.space)="$event.stopPropagation()"
                    class="!w-full !h-full rounded-lg !border-none !pt-2 !pb-2 !text-sm !m-0 !focus:outline-none !transition-all !duration-300" />
            </div>
        </div>

        <!-- All Employees Option -->
        <mat-option value="" class="!py-2 !px-[13px] employee-search-options" *ngIf="isShowAllEmp">
            <span class="employee-option-icon employee-option-icon--all">
              <mat-icon>group</mat-icon>
            </span>
            <span class="text-[14px]">All Employees</span>
        </mat-option>

        <!-- Filtered Employee List -->
        <mat-option *ngFor="let user of filteredUserList" [value]="user.id" class="employee-search-options">
            <img [src]="getProfileImageUrl(user)" class="dropdown-profile-image" alt="Profile"
                *ngIf="hasProfileImage(user)" />
            <div class="dropdown-default-avatar-wrapper" *ngIf="!hasProfileImage(user)">
                <ngx-avatars [initialsSize]="2" [textSizeRatio]="3" [name]="user.name" size="32">
                </ngx-avatars>
            </div>
            <span class="employee-name">{{user.name}}</span>
            <span
                *ngIf="showRustAgentBetaBadge(user)"
                class="agent-beta-badge agent-beta-badge--name"
                [matTooltip]="sysConfig.rustAgentNameBadgeTooltip"
                matTooltipPosition="below">{{ sysConfig.rustAgentBetaBadge }}</span>
        </mat-option>

        <!-- No Results Message -->
        <mat-option *ngIf="filteredUserList.length === 0 && employeeSearchCtrl.value" class="employee-search-options"
            disabled>
            <span class="no-results">No employees found</span>
        </mat-option>
    </mat-select>
    <!-- Multi-Select Dropdown -->
    <mat-select [placeholder]="placeholder" [formControl]="employeeMultiCtrl" *ngIf="!isInputSearch && isMultiSelect"
        multiple>
        <!-- Custom Trigger for Multi-Select -->
        <mat-select-trigger>
            <div *ngIf="employeeMultiCtrl.value && employeeMultiCtrl.value.length > 0">
                <div *ngIf="compactMultiTrigger" class="selected-employee-trigger selected-multi-trigger--compact !gap-2">
                    <ng-container *ngIf="compactMultiFirstUser as first">
                        <div class="trigger-profile-image-wrapper">
                            <img [src]="getProfileImageUrl(first)" class="trigger-profile-image" alt="Profile"
                                *ngIf="hasProfileImage(first)" />
                            <ngx-avatars [initialsSize]="2" [textSizeRatio]="3" size="28"
                                *ngIf="!hasProfileImage(first)" [name]="first.name">
                            </ngx-avatars>
                        </div>
                        <span class="trigger-employee-name">{{ first.name }}</span>
                        <span
                            *ngIf="showRustAgentBetaBadge(first)"
                            class="agent-beta-badge agent-beta-badge--name"
                            [matTooltip]="sysConfig.rustAgentNameBadgeTooltip"
                            matTooltipPosition="below">{{ sysConfig.rustAgentBetaBadge }}</span>
                    </ng-container>
                    <span class="multi-more-count" *ngIf="compactMultiExtraCount > 0">+{{ compactMultiExtraCount }}</span>
                </div>
                <div *ngIf="!compactMultiTrigger" class="!flex !items-center !justify-start !gap-2 w-full flex-wrap py-1">
                    @for (item of employeeMultiCtrl.value; track $index) {
                    <div class="selected-employee-trigger !gap-2">
                        <span class="trigger-employee-name" *ngIf="$index >= 1">, </span>
                        <div class="trigger-profile-image-wrapper">
                            <img [src]="getProfileImageUrl(getEmployeesNameFromId(item))"
                                class="trigger-profile-image" alt="Profile"
                                *ngIf="hasProfileImage(getEmployeesNameFromId(item))" />
                            <ngx-avatars [initialsSize]="2" [textSizeRatio]="3" size="28"
                                *ngIf="!hasProfileImage(getEmployeesNameFromId(item))"
                                [name]="getEmployeesNameFromId(item)?.name">
                            </ngx-avatars>
                        </div>
                        <span class="trigger-employee-name">{{ getEmployeesNameFromId(item)?.name }}</span>
                        <span
                            *ngIf="showRustAgentBetaBadge(item)"
                            class="agent-beta-badge agent-beta-badge--name"
                            [matTooltip]="sysConfig.rustAgentNameBadgeTooltip"
                            matTooltipPosition="below">{{ sysConfig.rustAgentBetaBadge }}</span>
                    </div>
                    }
                </div>
            </div>
            <span *ngIf="!employeeMultiCtrl.value || employeeMultiCtrl.value.length === 0">{{ placeholder }}</span>
        </mat-select-trigger>

        <!-- Search Input -->
        <div class="bg-[#f1f1f1] sticky top-0 px-2 py-2 z-10">
            <div
                class="relative bg-white rounded-lg transition-all duration-300 ease-out origin-right w-full border border-gray-300 border-solid px-3 flex items-center">
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="mr-1">
                    <path
                        d="M15.0259 13.8478L18.5951 17.4162L17.4159 18.5953L13.8476 15.0262C12.5199 16.0905 10.8684 16.6694 9.16675 16.667C5.02675 16.667 1.66675 13.307 1.66675 9.16699C1.66675 5.02699 5.02675 1.66699 9.16675 1.66699C13.3067 1.66699 16.6667 5.02699 16.6667 9.16699C16.6692 10.8687 16.0903 12.5201 15.0259 13.8478ZM13.3542 13.2295C14.4118 12.1419 15.0025 10.684 15.0001 9.16699C15.0001 5.94366 12.3892 3.33366 9.16675 3.33366C5.94341 3.33366 3.33341 5.94366 3.33341 9.16699C3.33341 12.3895 5.94341 15.0003 9.16675 15.0003C10.6838 15.0027 12.1417 14.4121 13.2292 13.3545L13.3542 13.2295Z"
                        fill="#B3B3B3" />
                </svg>
                <input #searchInp [formControl]="employeeSearchCtrl" [placeholder]="placeholder"
                    (keydown.space)="$event.stopPropagation()"
                    class="!w-full !h-full rounded-lg !border-none !pt-2 !pb-2 !text-sm !m-0 !focus:outline-none !transition-all !duration-300" />
            </div>
        </div>

        <mat-option *ngIf="filteredUserList.length === 0 && isMultiSelect" class="employee-search-options" disabled>
            <span class="no-results">No {{tags}} found</span>
        </mat-option>

        <!-- All Employees Option -->
        <mat-option value="" class="!py-2 !px-[13px] employee-search-options" *ngIf="isShowAllEmp">
            <span class="employee-option-icon employee-option-icon--all">
              <mat-icon>group</mat-icon>
            </span>
            <span class="text-[14px]">All Employees</span>
        </mat-option>

        <!-- Filtered Employee List -->
        <mat-option *ngFor="let user of userListSafe" [value]="user.id" class="employee-search-options"
            [style.display]="shouldHide(user) ? 'none' : 'flex'">
            <img [src]="getProfileImageUrl(user)" class="dropdown-profile-image" alt="Profile"
                *ngIf="hasProfileImage(user)" />
            <ngx-avatars *ngIf="!hasProfileImage(user)" [initialsSize]="2" [textSizeRatio]="3" [name]="user.name"
                size="32">
            </ngx-avatars>
            <span class="employee-name">{{user.name}}</span>
            <span
                *ngIf="showRustAgentBetaBadge(user)"
                class="agent-beta-badge agent-beta-badge--name"
                [matTooltip]="sysConfig.rustAgentNameBadgeTooltip"
                matTooltipPosition="below">{{ sysConfig.rustAgentBetaBadge }}</span>
        </mat-option>

        <!-- No Results Message -->
        <mat-option *ngIf="filteredUserList.length === 0 && employeeSearchCtrl.value && !isMultiSelect"
            class="employee-search-options" disabled>
            <span class="no-results">No employees found</span>
        </mat-option>
    </mat-select>
    <div class="relative bg-white rounded-lg transition-all duration-300 ease-out origin-right
         w-full px-0 flex items-center gap-2" *ngIf="isInputSearch">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="a">
            <path
                d="M15.0259 13.8478L18.5951 17.4162L17.4159 18.5953L13.8476 15.0262C12.5199 16.0905 10.8684 16.6694 9.16675 16.667C5.02675 16.667 1.66675 13.307 1.66675 9.16699C1.66675 5.02699 5.02675 1.66699 9.16675 1.66699C13.3067 1.66699 16.6667 5.02699 16.6667 9.16699C16.6692 10.8687 16.0903 12.5201 15.0259 13.8478ZM13.3542 13.2295C14.4118 12.1419 15.0025 10.684 15.0001 9.16699C15.0001 5.94366 12.3892 3.33366 9.16675 3.33366C5.94341 3.33366 3.33341 5.94366 3.33341 9.16699C3.33341 12.3895 5.94341 15.0003 9.16675 15.0003C10.6838 15.0027 12.1417 14.4121 13.2292 13.3545L13.3542 13.2295Z"
                fill="#B3B3B3" />
        </svg>
        <input matInput #searchInp [placeholder]="placeholder"
            class="!w-full !h-full rounded-lg border-none !text-base !m-0 !focus:outline-none !transition-all !duration-300" />
    </div>
</mat-form-field>